export default __webpack_public_path__ + "static/media/bg_banner_bottom-lg.d9257213.jpeg";